const submission_prefix = 'SUBMISSIONS_APP';
const account_setup_prefix = 'ACCOUNT_SETUP';
const notifications_prefix = 'NOTIFICATIONS';
const account_prefix = 'ACCOUNT';

// me
export const SET_USER_INFO = `${submission_prefix}/SET_USER_INFO`;
export const GET_USER_INFO = `${submission_prefix}/GET_USER_INFO`;
export const GET_USER_INFO_SUCCESS = `${submission_prefix}/GET_USER_INFO_SUCCESS`;
export const GET_USER_INFO_FAIL = `${submission_prefix}/GET_USER_INFO_FAIL`;
export const SET_IS_FORBIDDEN = `${submission_prefix}/SET_IS_FORBIDDEN`;
export const SET_LOGIN_WEDDINGS = `${submission_prefix}/SET_LOGIN_WEDDINGS`;

// account
export const UPDATE_USER_INFO = `${account_prefix}/UPDATE_USER_INFO`;
export const UPDATE_USER_INFO_SUCCESS = `${account_prefix}/UPDATE_USER_INFO_SUCCESS`;
export const UPDATE_USER_INFO_FAIL = `${account_prefix}/UPDATE_USER_INFO_FAIL`;

export const GET_NOTIFICATION_PREFERENCES = `${account_prefix}/GET_NOTIFICATION_PREFERENCES`;
export const GET_NOTIFICATION_PREFERENCES_SUCCESS = `${account_prefix}/GET_NOTIFICATION_PREFERENCES_SUCCESS`;
export const GET_NOTIFICATION_PREFERENCES_FAIL = `${account_prefix}/GET_NOTIFICATION_PREFERENCES_FAIL`;

export const SAVE_NOTIFICATION_PREFERENCE = `${account_prefix}/SAVE_NOTIFICATION_PREFERENCE`;
export const SAVE_NOTIFICATION_PREFERENCE_SUCCESS = `${account_prefix}/SAVE_NOTIFICATION_PREFERENCE_SUCCESS`;
export const SAVE_NOTIFICATION_PREFERENCE_FAIL = `${account_prefix}/SAVE_NOTIFICATION_PREFERENCE_FAIL`;

export const UPDATE_LOGIN_SAVED_COLORS = `${account_prefix}/UPDATE_LOGIN_SAVED_COLORS`;
export const UPDATE_LOGIN_SAVED_COLORS_SUCCESS = `${account_prefix}/UPDATE_LOGIN_SAVED_COLORS_SUCCESS`;
export const UPDATE_LOGIN_SAVED_COLORS_FAIL = `${account_prefix}/UPDATE_LOGIN_SAVED_COLORS_FAIL`;

export const UPDATE_LOGIN_PREFERENCES = `${account_prefix}/UPDATE_LOGIN_PREFERENCES`;

// Integration
export const CREATE_INTEGRATION_VCAL_GRANT = `${account_prefix}/CREATE_INTEGRATION_VCAL_GRANT`;
export const CREATE_INTEGRATION_VCAL_GRANT_SUCCESS = `${account_prefix}/CREATE_INTEGRATION_VCAL_GRANT_SUCCESS`;
export const CREATE_INTEGRATION_VCAL_GRANT_FAIL = `${account_prefix}/CREATE_INTEGRATION_VCAL_GRANT_FAIL`;
export const DELETE_INTEGRATION_ACCOUNT = `${account_prefix}/DELETE_INTEGRATION_ACCOUNT`;
export const DELETE_INTEGRATION_ACCOUNT_INIT = `${account_prefix}/DELETE_INTEGRATION_ACCOUNT_INIT`;
export const DELETE_INTEGRATION_ACCOUNT_SUCCESS = `${account_prefix}/DELETE_INTEGRATION_ACCOUNT_SUCCESS`;
export const DELETE_INTEGRATION_ACCOUNT_FAIL = `${account_prefix}/DELETE_INTEGRATION_ACCOUNT_FAIL`;
export const CREATE_LOGIN_CALENDAR_INIT = `${account_prefix}/CREATE_LOGIN_CALENDAR_INIT`;
export const CREATE_LOGIN_CALENDAR = `${account_prefix}/CREATE_LOGIN_CALENDAR`;
export const CREATE_LOGIN_CALENDAR_SUCCESS = `${account_prefix}/CREATE_LOGIN_CALENDAR_SUCCESS`;
export const CREATE_LOGIN_CALENDAR_FAIL = `${account_prefix}/CREATE_LOGIN_CALENDAR_FAIL`;
export const DELETE_LOGIN_CALENDAR_INIT = `${account_prefix}/DELETE_LOGIN_CALENDAR_INIT`;
export const DELETE_LOGIN_CALENDAR = `${account_prefix}/DELETE_LOGIN_CALENDAR`;
export const DELETE_LOGIN_CALENDAR_SUCCESS = `${account_prefix}/DELETE_LOGIN_CALENDAR_SUCCESS`;
export const DELETE_LOGIN_CALENDAR_FAIL = `${account_prefix}/DELETE_LOGIN_CALENDAR_FAIL`;

export const GET_LINKED_ACCOUNTS = `${account_prefix}/GET_LINKED_ACCOUNTS`;

// Auth Error
export const PUSH_AUTH_ERROR = Symbol(`${notifications_prefix}/PUSH_AUTH_ERROR`);

// Site notifications
export const SET_SHOW_PAUSED_MODAL = `${submission_prefix}/SET_SHOW_PAUSED_MODAL`;
export const SET_NOTIFICATIONS_CENTER_OPEN = `${submission_prefix}/SET_NOTIFICATIONS_CENTER_OPEN`;
export const SET_NOTIFICATIONS_CENTER_TAB = `${submission_prefix}/SET_NOTIFICATIONS_CENTER_TAB`;
export const PUSH_SITE_NOTIFICATION = `${submission_prefix}/PUSH_SITE_NOTIFICATION`;
export const REMOVE_SITE_NOTIFICATION = `${submission_prefix}/REMOVE_SITE_NOTIFICATION`;

// submissions
export const SET_USER_SUBMISSIONS = `${submission_prefix}/SET_SUBMISSIONS`;
export const GET_USER_SUBMISSIONS = `${submission_prefix}/GET_SUBMISSIONS`;
export const ADD_NEW_SUBMISSION = `${submission_prefix}/ADD_NEW_SUBMISSION`;
export const CHANGE_SUBMISSION = `${submission_prefix}/CHANGE_SUBMISSION`;
export const SWITCH_USER_ROLE = `${submission_prefix}/SWITCH_USER_ROLE`;
export const SHOW_ROLE_SWITCHER = `${submission_prefix}/SHOW_ROLE_SWITCHER`;
export const LOAD_ACCOUNT_INFO = `${account_setup_prefix}/LOAD_ACCOUNT_INFO`;
export const SET_DRUPAL_INFO = `${submission_prefix}/SET_DRUPAL_INFO`;
export const SET_PHOTOGRAPHERS = `${submission_prefix}/SET_PHOTOGRAPHERS`;
export const SET_LEAD_VIEW_OPTIONS = `${submission_prefix}/SET_LEAD_VIEW_OPTIONS`;
export const SET_PROJECTS_VIEW_OPTIONS = `${submission_prefix}/SET_PROJECTS_VIEW_OPTIONS`;
export const SET_NOTES_VIEW_OPTIONS = `${submission_prefix}/SET_NOTES_VIEW_OPTIONS`;

// notifcations
export const GET_CHECKIN = Symbol(`${notifications_prefix}/GET_CHECKIN`);
export const GET_CHECKIN_SUCCESS = Symbol(`${notifications_prefix}/GET_CHECKIN_SUCCESS`);
export const GET_NOTIFICATIONS = Symbol(`${notifications_prefix}/GET_NOTIFICATIONS`);
export const GET_NOTIFICATIONS_SUCCESS = Symbol(`${notifications_prefix}/GET_NOTIFICATIONS_SUCCESS`);
export const GET_NOTIFICATIONS_FAIL = Symbol(`${notifications_prefix}/GET_NOTIFICATIONS_FAIL`);
export const MARK_NOTIFICATIONS_READ = Symbol(`${notifications_prefix}/MARK_NOTIFICATIONS_READ`);
export const MARK_NOTIFICATIONS_READ_SUCCESS = Symbol(`${notifications_prefix}/MARK_NOTIFICATIONS_READ_SUCCESS`);
export const MARK_NOTIFICATION_READ = Symbol(`${notifications_prefix}/MARK_NOTIFICATION_READ`);
export const MARK_NOTIFICATION_READ_SUCCESS = Symbol(`${notifications_prefix}/MARK_NOTIFICATION_READ_SUCCESS`);

export const GET_ADDT_NOTIFICATIONS = Symbol(`${notifications_prefix}/GET_ADDT_NOTIFICATIONS`);
export const GET_ADDT_NOTIFICATIONS_SUCCESS = Symbol(`${notifications_prefix}/GET_ADDT_NOTIFICATIONS_SUCCESS`);
export const ABORT_GET_NOTIFICATIONS = Symbol(`${notifications_prefix}/ABORT_GET_NOTIFICATIONS`);

export const GET_TASKS = Symbol(`${notifications_prefix}/GET_TASKS`);
export const GET_GENERAL_TASKS = Symbol(`${notifications_prefix}/GET_TASKS`);
export const GET_PROJECT_TASKS = Symbol(`${notifications_prefix}/GET_PROJECT_TASKS`);
export const GET_LEAD_TASKS = Symbol(`${notifications_prefix}/GET_LEAD_TASKS`);
export const GET_TASKS_SUCCESS = Symbol(`${notifications_prefix}/GET_TASKS_SUCCESS`);
export const GET_FOCUS_TASKS = Symbol(`${notifications_prefix}/GET_FOCUS_TASKS`);
export const GET_FOCUS_TASKS_SUCCESS = Symbol(`${notifications_prefix}/GET_FOCUS_TASKS_SUCCESS`);
export const GET_TASKS_FAIL = Symbol(`${notifications_prefix}/GET_TASKS_FAIL`);
export const FETCH_SINGLE_TASK = Symbol(`${notifications_prefix}/FETCH_SINGLE_TASK`);
export const FETCH_SINGLE_TASK_SUCCESS = Symbol(`${notifications_prefix}/FETCH_SINGLE_TASK_SUCCESS`);
export const FETCH_SINGLE_TASK_FAIL = Symbol(`${notifications_prefix}/FETCH_SINGLE_TASK_FAIL`);
export const CREATE_NEW_TASK = Symbol(`${notifications_prefix}/CREATE_NEW_TASK`);
export const UPDATE_TASK_DETAIL = Symbol(`${notifications_prefix}/UPDATE_TASK_DETAIL`);
export const UPDATE_TASK_DETAIL_SUCCESS = Symbol(`${notifications_prefix}/UPDATE_TASK_DETAIL_SUCCESS`);
export const DELETE_TASK = Symbol(`${notifications_prefix}/DELETE_TASK`);
export const DELETE_TASK_SUCCESS = Symbol(`${notifications_prefix}/DELETE_TASK_SUCCESS`);
export const UPDATE_TASK_SUCCESS = Symbol(`${notifications_prefix}/UPDATE_TASK_SUCCESS`);
export const UPDATE_TASK_STORE_BY_ID = Symbol(`${notifications_prefix}/UPDATE_TASK_STORE_BY_ID`);

export const CREATE_NEW_COMMENT = Symbol(`${notifications_prefix}/CREATE_NEW_COMMENT`);
export const UPDATE_COMMENT_DETAIL = Symbol(`${notifications_prefix}/UPDATE_COMMENT_DETAIL`);
export const DELETE_COMMENT = Symbol(`${notifications_prefix}/DELETE_COMMENT`);

export const ADD_NEW_ASSIGNMENT = Symbol(`${notifications_prefix}/ADD_NEW_ASSIGNMENT`);
export const UPDATE_ASSIGNMENT = Symbol(`${notifications_prefix}/UPDATE_ASSIGNMENT`);
export const DROP_ASSIGNMENT = Symbol(`${notifications_prefix}/DROP_ASSIGNMENT`);
export const ACTION_ASSIGNMENT_SUCCESS = Symbol(`${notifications_prefix}/ACTION_ASSIGNMENT_SUCCESS`);

export const CREATE_TASK_REMINDER = Symbol(`${notifications_prefix}/CREATE_TASK_REMINDER`);
export const UPDATE_TASK_REMINDER = Symbol(`${notifications_prefix}/UPDATE_TASK_REMINDER`);
export const DELETE_TASK_REMINDER = Symbol(`${notifications_prefix}/DELETE_TASK_REMINDER`);
export const TASK_REMINDER_SUCCESS = Symbol(`${notifications_prefix}/TASK_REMINDER_SUCCESS`);
export const TASK_REMINDER_FAILURE = Symbol(`${notifications_prefix}/TASK_REMINDER_FAILURE`);

export const REORDER_TASK = Symbol(`${notifications_prefix}/REORDER_TASK`);
export const REORDER_TASK_COMPLETE = Symbol(`${notifications_prefix}/REORDER_TASK_COMPLETE`);

// Site errors
export const PUSH_SITE_ERROR = `${submission_prefix}/PUSH_SITE_ERROR`;
export const REMOVE_SITE_ERROR = `${submission_prefix}/REMOVE_SITE_ERROR`;
export const PUSH_404_ERROR = `${submission_prefix}/PUSH_404_ERROR`;
export const REMOVE_404_ERROR = `${submission_prefix}/REMOVE_404_ERROR`;
